// extracted by mini-css-extract-plugin
export default {"container":"InfoRestaurant_container__BbsDu","title":"InfoRestaurant_title__EGmsN","flex":"InfoRestaurant_flex__Ld82P","column":"InfoRestaurant_column__Q0h3E"};